// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"21b4462dabf43384","713":"d47c4c43e792957c"}[chunkId] + ".js";
};